import { setTerms } from './helpers';

export const setBuildingHeatingType = setTerms('building_heating_type');
